import React from 'react';
import { FormControlLabel, Switch, TextField, Grid, Typography, FormHelperText } from '@mui/material';

export default function ProductReservationSettings({ productData, setProductData }) {

  const handleChange = (e) => {
    setProductData({
      ...productData,
      [e.target.name]: e.target.value
    });
  };

  const handleSwitch = (e) => {
    setProductData({
      ...productData,
      [e.target.name]: e.target.checked
    });
  };

  return (
    <>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
          Reservas y Turnos
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(productData.is_reservable)}
                onChange={handleSwitch}
                name="is_reservable"
              />
            }
            label="¿Este producto requiere reserva de horario?"
          />
          <FormHelperText>
              Activa esto para canchas, mesas o servicios profesionales por hora.
          </FormHelperText>
        </Grid>

        {productData.is_reservable && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Duración del Turno (Minutos)"
              name="duration_minutes"
              type="number"
              value={productData.duration_minutes || ''}
              onChange={handleChange}
              helperText="Ej: 60 para bloques de 1 hora."
              size="small"
              required
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}